export default "__VITE_ASSET__DU0Mv5$P__"